import {
  UserFullInfoQuery,
  UserFullInfoQuery$data,
} from '@bts-web/data-layer/server';
import { Mutable } from '../../trade/utils';

export type InitialUserDataResponseType = NonNullable<
  NonNullable<Mutable<UserFullInfoQuery>>['response']
>;

export type LowercaseUserLanguage = Lowercase<
  NonNullable<UserFullInfoQuery$data['me']>['language']
>;

export enum UserTypes {
  USER = 'User',
  BUSINESS_USER = 'BusinessUser',
}

export type AppUserFullInfo = Omit<
  NonNullable<UserFullInfoQuery$data['me']>,
  'language' | 'compliancePolicy'
> & {
  userType: UserTypes;
  isReadOnlyUser: boolean;
  autoStakingEnabled?: boolean;
  // TODO: remove mock when automaticWithdrawalsEnabled is available on the UserFullInfoQuery
  automaticWithdrawalsEnabled?: boolean;
  isIslamicUser: boolean;
  language: LowercaseUserLanguage;
};

export enum BusinessUserRole {
  EXECUTION = 'EXECUTION',
  READONLY = 'READ_ONLY',
}
